import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";

export const EditableTableRow = React.memo(({ row, rowIndex, onUpdate }) => {
	const handleChange = (column) => (e) => {
		onUpdate(rowIndex, column, e);
	};

	return (
		<tr key={`p-${row.pkey}`}>
			{["users_name", "base_pay", "commission", "gas_credits", "feedback", "bonus", "subtractions", "total_pay", "notes"].map((col) => (
				<td key={col} className="text-center" title="Edit">
					{col === "bonus" ? (
						<Checkbox
							checked={!!row[col]}
							color="primary"
							onChange={handleChange(col)}
						/>
					) : (
						<TextField
							value={row[col]}
							onChange={handleChange(col)}
							variant="outlined"
						/>
					)}
				</td>
			))}
		</tr>
	);
});
